<template>
  <el-container class="use-background">
    <el-drawer
      title="Navigasi"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose">
      <Aside />
    </el-drawer>
    <el-header>
      <el-button class="hidden-md-and-up" @click="drawer = true" icon="el-icon-s-unfold" style="margin-right: 10px;" >
      </el-button>
      <img :src="image_brand" class="image-brand" />
      <span class="header-right">
        <el-dropdown trigger="click" @command="handleCommand" placement="bottom-end">
          <span class="el-dropdown-link">
            <el-avatar icon="el-icon-user-solid"></el-avatar><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item disabled>{{email}}</el-dropdown-item>
            <el-dropdown-item icon="el-icon-key" command="ganti-password">Ganti Password</el-dropdown-item>
            <el-dropdown-item icon="el-icon-edit" command="tentang-penulis" divided>Tentang Penulis</el-dropdown-item>

            <el-dropdown-item icon="el-icon-switch-button" command="keluar">Keluar</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </el-header>
    <el-container>
      <el-aside width="250px" class="hidden-sm-and-down">
        <Aside />
      </el-aside>
      <el-container>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import Aside from '../components/Aside'
import { auth } from '../firebase'

export default {
  data() {
    return {
      email: this.$store.state.user.email,
      drawer: false,
      direction: 'ltr',
      image_brand: require('../assets/logo-putih.png'),
    }
  },
  components: {
    Aside
  },
  methods: {
    handleCommand: function (command) {
      if (command == 'keluar'){
        auth.signOut()
      } else if (command == 'ganti-password') {
        this.$router.push({name: 'ganti-password'})
      } else if (command == 'tentang-penulis') {
        this.$router.push({name: 'tentang-penulis'})
      }
    },
    handleClose(done) {
      done();
    }
  },
  mounted(){
    
  }
}
</script>
